var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DoNotTrack',{attrs:{"placeholder":"👤"}},[_c('span',{class:{
      avatar: true,
      default: !_vm.hasAvatar
    },style:(_vm.getStyle)},[(_vm.hasAvatar)?_c('img',{attrs:{"src":_vm.avatarUrl,"role":"presentation","alt":"User photo"}}):_c('img',{attrs:{"src":require("@/assets/images/icons/avatar-icon.svg"),"role":"presentation","alt":"User photo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }